// rootStore from query
export const QUERY_LANGUAGE = 'language';
export const QUERY_COUNTRY = 'country';
export const QUERY_CURRENCY = 'currency';
export const QUERY_ACCESS_TOKEN = 'access_token';
export const QUERY_LOGIN_TOKEN = 'login_token';

// rootStore from cookie
export const COOKIE_LOCALE = 'NEXT_LOCALE';
export const COOKIE_LANG = 'LANGUAGE';
export const COOKIE_COUNTRY = 'COUNTRY';
export const COOKIE_CURRENCY = 'CURRENCY';
export const COOKIE_ACCESS_TOKEN = 'ACCESS_TOKEN';
export const COOKIE_LOGIN_TOKEN = 'LOGIN_TOKEN';
export const COOKIE_IS_GUEST_USER = 'IS_GUEST_USER';
export const COOKIE_DEBUG_TRANS= 'DEBUG_TRANS';
// 加车，立即购买
export const COOKIE_VARIANT_NUMS_ITEMS = 'VARIANT_NUMS_ITEMS';
// 直接购买存储的参数 可包裹多个参数 (只保存 VARIANT_NUMS_ITEMS 不能满足业务需求了)
export const COOKIE_BUY_NOW_DATA = 'BUY_NOW_DATA';
export const COOKIE_CART_SELECTED_IDS = 'CART_SELECTED_IDS';
export const COOKIE_LAST_ORDER_ID = 'LAST_ORDER_ID';

// tracker
export const STORAGE_DISABLE_TRACKER = 'DISABLE_TRACKER';
export const QUERY_DISABLE_TRACKER = 'disable_tracker';

// search suggest
export const STORAGE_SEARCH_SUGGEST_LIST = 'STORAGE_SEARCH_SUGGEST_LIST';

// debug query
export const DEBUG_TRACKER = 'debug_tracker';
export const DEBUG_SERVER = 'debug_server';
export const DEBUG_APP = 'debug_app';
export const DEBUG_NODE_CACHE = 'debug_node_cache';
export const DEBUG_FRAME = 'debug_frame';
export const DEBUG_SOURCEMAP = 'debug_sourcemap';
export const DEBUG_AGE_GATE = 'debug_age';
export const DEBUG_TRANS = 'debug_trans';
// export const DEBUG_TRANS = 't';

// app webview 第一次进入页面
export const APP_FIRST_ENTRY = 'firstEntry';

//引导注册浮层
export const COOKIE_FIXED_REGISTER = 'FIXED_REGISTER'; //引导注册浮层状态：1不展示，2不展开
export const FIXED_REGISTER_NO_LOAD = '1'; //引导注册浮层状态：1不展示，2不展开
export const FIXED_REGISTER_NO_EXPAND = '2'; //引导注册浮层状态：1不展示，2不展开

// 正则表达式 - path
export const REG_LIST_PATH = /[^\/]*-c\d+$/;
export const REG_CAT_PATH = /[^\/]*-a\d+$/;
export const REG_PRODUCT_PATH = /[^\/]*-p\d+(-v\d+)*$/;
export const REG_TECHNICAL_GUIDE_PATH = /[^\/]*-t\d+$/;

// 提示购物车 活动过期 api 返回 code
export const DEALER_TOTAL_INSUFFICIENT_API_CODE = 300051
// 500017 分组购物车校验
// 500018 用户在未登录情况下，添加需要积分换取的商品
// 500019 用户添加的换购商品已达到上限
// 500020 用户购物车里面的商品金额不满足换购条件
// 500021 用户的积分不足够换购商品
// 500022 活动已经结束
export const INVALID_BACK_CART_CODES = [500017, 500018, 500019, 500020, 500021, 500022];
// url promo_code 参数验证跳转登录
export const CHECK_BUY_NOW_GO_LOGIN = 500027;
// 500026 加车时发现活动已经结束，或者活动中没有这个商品了
export const CODE_NEED_LOGIN = 100001;
export const CODE_FLUSH_PAGE = 2002;
export const CODE_RETURN_TO_CART = 2003;
export const CODE_NEED_LOGIN_WEAK = 2004;
export const CODE_FLUSH_PAGE_WEAK = 2005;
export const CODE_RETURN_TO_CART_WEAK = 2006;
export const CODE_NOT_LOGIN_VERIFY_EMAIL = 2007; // 未登录/匿名登录状态下，需要用户登录并判断邮箱是否已校验
export const CODE_VERIFY_EMAIL = 2008; // 已登陆需要验证邮箱

export const WHOLESALE_ROOT_PROD = 'https://wholesale.vivosun.com/';
export const WHOLESALE_ROOT_PRE = 'https://pre-wholesale.next.vivosun.com/';
export const WHOLESALE_ROOT_TEST = 'https://vivosun-wholesale.sino-beta.com/';
export const WHOLESALE_ROOT_DEV = 'http://localhost:3008/';
export const WHOLESALE_ROOT_MAP = {
    prod: WHOLESALE_ROOT_PROD,
    pre: WHOLESALE_ROOT_PRE,
    test: WHOLESALE_ROOT_TEST,
    dev: WHOLESALE_ROOT_DEV,
}
export const WHOLESALE_NO_LOGIN_PAGES = [ // wholesale 不登录鉴权的页面
    '/become-a-reseller',
    '/set-password',
]
